import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { HelmetProvider } from 'react-helmet-async';
import { useAuthStore } from './stores/authStore';
import 'react-toastify/dist/ReactToastify.css';

// Admin pages
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import FeaturesList from './pages/admin/FeaturesList';
import FeaturesForm from './pages/admin/FeaturesForm';
import ClientReferencesList from './pages/admin/ClientReferencesList';
import ClientReferencesForm from './pages/admin/ClientReferencesForm';
import BankAccountsList from './pages/admin/BankAccountsList';
import BankAccountForm from './pages/admin/BankAccountForm';
import BanksList from './pages/admin/BanksList';
import BankForm from './pages/admin/BankForm';
import IntegrationCategoriesList from './pages/admin/IntegrationCategoriesList';
import IntegrationCategoryForm from './pages/admin/IntegrationCategoryForm';
import IntegrationCompaniesList from './pages/admin/IntegrationCompaniesList';
import IntegrationCompanyForm from './pages/admin/IntegrationCompanyForm';
import FaqCategoriesList from './pages/admin/FaqCategoriesList';
import FaqCategoryForm from './pages/admin/FaqCategoryForm';
import FaqQuestionsList from './pages/admin/FaqQuestionsList';
import FaqQuestionForm from './pages/admin/FaqQuestionForm';
import ContactInfoList from './pages/admin/ContactInfoList';
import ContactInfoForm from './pages/admin/ContactInfoForm';
import UsersList from './pages/admin/UsersList';
import UserForm from './pages/admin/UserForm';
import AdminLayout from './components/layout/AdminLayout';

// Web pages
import Home from './pages/web/Home';
import Kurumsal from './pages/web/Kurumsal';
import Ozellikler from './pages/web/Ozellikler';
import Entegrasyonlar from './pages/web/Entegrasyonlar';
import Iletisim from './pages/web/Iletisim';
import Referanslar from './pages/web/Referanslar';
import BankaHesap from './pages/web/BankaHesap';
import GizlilikSozlesmesi from './pages/web/GizlilikSozlesmesi';
import CerezSozlesmesi from './pages/web/CerezSozlesmesi';
import SikcaSorulanSorular from './pages/web/SikcaSorulanSorular';
import OzelFiyatlandirma from './pages/web/OzelFiyatlandirma';
import WebLayout from './components/layout/WebLayout';

function App() {
  const { checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin/login" element={<Login />} />
                 <Route path="/admin" element={<AdminLayout />}>
                   <Route path="dashboard" element={<Dashboard />} />
                   <Route path="features" element={<FeaturesList />} />
                   <Route path="features/create" element={<FeaturesForm />} />
                   <Route path="features/:id/edit" element={<FeaturesForm />} />
                   <Route path="client-references" element={<ClientReferencesList />} />
                   <Route path="client-references/create" element={<ClientReferencesForm />} />
                   <Route path="client-references/:id/edit" element={<ClientReferencesForm />} />
                   <Route path="banks" element={<BanksList />} />
                   <Route path="banks/create" element={<BankForm />} />
                   <Route path="banks/:id/edit" element={<BankForm />} />
                   <Route path="integration-categories" element={<IntegrationCategoriesList />} />
                   <Route path="integration-categories/create" element={<IntegrationCategoryForm />} />
                   <Route path="integration-categories/:id/edit" element={<IntegrationCategoryForm />} />
                   <Route path="integration-companies" element={<IntegrationCompaniesList />} />
                   <Route path="integration-companies/create" element={<IntegrationCompanyForm />} />
                   <Route path="integration-companies/:id/edit" element={<IntegrationCompanyForm />} />
                   <Route path="faq-categories" element={<FaqCategoriesList />} />
                   <Route path="faq-categories/create" element={<FaqCategoryForm />} />
                   <Route path="faq-categories/:id/edit" element={<FaqCategoryForm />} />
                   <Route path="faq-questions" element={<FaqQuestionsList />} />
                   <Route path="faq-questions/create" element={<FaqQuestionForm />} />
                   <Route path="faq-questions/:id/edit" element={<FaqQuestionForm />} />
                   <Route path="contact-info" element={<ContactInfoList />} />
                   <Route path="contact-info/create" element={<ContactInfoForm />} />
                   <Route path="contact-info/:id/edit" element={<ContactInfoForm />} />
                   <Route path="users" element={<UsersList />} />
                   <Route path="users/create" element={<UserForm />} />
                   <Route path="users/:id/edit" element={<UserForm />} />
                   <Route path="bank-accounts" element={<BankAccountsList />} />
                   <Route path="bank-accounts/create" element={<BankAccountForm />} />
                   <Route path="bank-accounts/:id/edit" element={<BankAccountForm />} />
                 </Route>
          
        {/* Web Routes */}
        <Route path="/" element={
          <WebLayout 
            title=""
            description="ISP Radius, internet servis sağlayıcıları için geliştirilmiş kapsamlı abone yönetim sistemi. BTK loglama, Mikrotik entegrasyonu, otomatik faturalama ve daha fazlası."
            keywords="ISP Radius, ISS, abone yönetim sistemi, BTK loglama, Mikrotik entegrasyonu, otomatik faturalama, internet servis sağlayıcısı, telekomünikasyon, abone takibi, fatura yönetimi"
          >
            <Home />
          </WebLayout>
        } />
        <Route path="/kurumsal" element={
          <WebLayout 
            title="Kurumsal"
            description="ISP Radius hakkında bilgi alın. Vizyonumuz, misyonumuz ve şirket değerlerimizi keşfedin. Güvenilir ve yenilikçi çözüm ortağı olma yolculuğumuz."
            keywords="ISP Radius kurumsal, şirket bilgileri, vizyon, misyon, değerler, güvenilir çözüm ortağı, telekomünikasyon şirketi"
          >
            <Kurumsal />
          </WebLayout>
        } />
        <Route path="/ozellikler" element={
          <WebLayout 
            title="Özellikler"
            description="ISP Radius'un güçlü özelliklerini keşfedin. Abone yönetimi, BTK loglama, Mikrotik entegrasyonu, Türk Telekom entegrasyonu, ödeme yönetimi ve çağrı merkezi sistemi."
            keywords="ISP Radius özellikler, abone yönetimi, BTK loglama, Mikrotik entegrasyonu, Türk Telekom entegrasyonu, ödeme yönetimi, çağrı merkezi, 7/24 destek"
          >
            <Ozellikler />
          </WebLayout>
        } />
        <Route path="/entegrasyonlar" element={
          <WebLayout 
            title="Entegrasyonlar"
            description="ISP Radius'un desteklediği entegrasyonları keşfedin. SMS servisleri, sanal POS sistemleri, e-fatura entegrasyonları, kurum ödemeleri ve muhasebe yazılımları."
            keywords="ISP Radius entegrasyonlar, SMS entegrasyonu, sanal POS, e-fatura, kurum ödemeleri, muhasebe yazılımı, sistem entegrasyonu"
          >
            <Entegrasyonlar />
          </WebLayout>
        } />
        <Route path="/iletisim" element={
          <WebLayout 
            title="İletişim"
            description="ISP Radius ile iletişime geçin. Adres, telefon ve e-posta bilgilerimiz. İletişim formu ile hızlıca bize ulaşın. 7/24 teknik destek hizmetimiz."
            keywords="ISP Radius iletişim, telefon, adres, e-posta, iletişim formu, teknik destek, müşteri hizmetleri"
          >
            <Iletisim />
          </WebLayout>
        } />
        <Route path="/referanslar" element={
          <WebLayout 
            title="Referanslar"
            description="ISP Radius'u tercih eden müşterilerimizi keşfedin. Başarılı projelerimiz ve memnun müşterilerimizin referansları. Güvenilir çözüm ortağımızın kanıtı."
            keywords="ISP Radius referanslar, müşteri referansları, başarılı projeler, memnun müşteriler, güvenilir çözüm ortağı"
          >
            <Referanslar />
          </WebLayout>
        } />
        <Route path="/banka-hesap-bilgileri" element={
          <WebLayout 
            title="Banka Hesap Bilgileri"
            description="ISP Radius hizmetleri için ödeme yapabileceğiniz banka hesap bilgileri. Garanti Bankası, VakıfBank ve Enpara.com hesap bilgilerimiz."
            keywords="ISP Radius banka hesap bilgileri, ödeme bilgileri, IBAN, Garanti Bankası, VakıfBank, Enpara.com"
          >
            <BankaHesap />
          </WebLayout>
        } />
        <Route path="/gizlilik-sozlesmesi" element={
          <WebLayout 
            title="Gizlilik Sözleşmesi"
            description="ISP Radius gizlilik sözleşmesi. Kişisel verilerinizin korunması ve işlenmesi hakkında detaylı bilgiler. KVKK uyumlu gizlilik politikamız."
            keywords="ISP Radius gizlilik sözleşmesi, kişisel veri korunması, KVKK, gizlilik politikası, veri güvenliği"
          >
            <GizlilikSozlesmesi />
          </WebLayout>
        } />
        <Route path="/cerez-sozlesmesi" element={
          <WebLayout 
            title="Çerez Sözleşmesi"
            description="ISP Radius çerez sözleşmesi. Web sitemizde kullanılan çerezler ve bunların amaçları hakkında detaylı bilgiler. Çerez tercihlerinizi yönetin."
            keywords="ISP Radius çerez sözleşmesi, çerez politikası, web çerezleri, çerez tercihleri, KVKK çerez"
          >
            <CerezSozlesmesi />
          </WebLayout>
        } />
        <Route path="/sikca-sorulan-sorular" element={
          <WebLayout 
            title="Sıkça Sorulan Sorular"
            description="ISP Radius hakkında en çok merak edilen sorular ve cevapları. Genel sorular, teknik özellikler, faturalama, entegrasyonlar ve destek konularında SSS."
            keywords="ISP Radius SSS, sıkça sorulan sorular, teknik destek, genel sorular, faturalama soruları, entegrasyon soruları"
          >
            <SikcaSorulanSorular />
          </WebLayout>
        } />
        <Route path="/fiyatlandirma" element={<OzelFiyatlandirma />} />
          
          {/* 404 Route */}
          <Route path="*" element={<WebLayout><div style={{ padding: '20px', textAlign: 'center' }}><h1>404 - Sayfa Bulunamadı</h1><a href="/" style={{ color: '#0ea5e9' }}>Ana Sayfa</a></div></WebLayout>} />
        </Routes>
        <ToastContainer 
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          toastStyle={{
            backgroundColor: 'rgba(15, 23, 42, 0.95)',
            color: '#ffffff',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)',
          }}
          progressStyle={{
            background: 'linear-gradient(to right, #f59e0b, #ef4444)',
          }}
        />
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;